import NavBar from '../NavBar/NavBar';
import { Outlet, useLocation } from "react-router-dom"
import LogoBar from '../LogoBar/LogoBar';
import Footer from '../Footer/Footer';
import SiteSettingsBar from '../SiteSettingsBar/SiteSettingsBar';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

function MainPage(props: {
    data: any;
}) {

  const location = useLocation();

  function setWebsiteLanguage(lang: string) {
    localStorage.removeItem("website_language");
    localStorage.setItem("website_language", `${lang}`);
    document.location.reload()
  }

  return (
    <div
        className="flex flex-col
                  w-full min-h-[100vh]
                  overflow-y-auto"
    >
      <SiteSettingsBar 
        setWebsiteLanguageFunction = {setWebsiteLanguage}
      />
      <LogoBar />
      <NavBar 
        data={ props.data }
      />
      <Outlet />
      <Footer />
    </div>
  )
}

export default MainPage